export enum SortOption {
  Default,
  Up,
  Down,
}
